import { syncStorageKey } from 'constants/autosave';
import { useQuery } from 'react-query';
export var useOutOfSyncFocusCheck = function (outOfSyncDisclosure, signed, initialized, noteId) {
    useQuery('out-of-sync', function () {
        var localStorageUpdatedAt = window.localStorage.getItem(syncStorageKey(noteId !== null && noteId !== void 0 ? noteId : ''));
        var sessionStorageUpdatedAt = window.sessionStorage.getItem(syncStorageKey(noteId !== null && noteId !== void 0 ? noteId : ''));
        if (localStorageUpdatedAt !== sessionStorageUpdatedAt) {
            outOfSyncDisclosure.onOpen();
        }
    }, { refetchOnWindowFocus: true, enabled: !!noteId && !signed && !!initialized });
};
